import React, { useState, useEffect } from 'react';
import { requestNotificationPermission, isNotificationSupported } from '../utils/notificationUtils';

const NotificationPermission = () => {
  const [permission, setPermission] = useState(
    isNotificationSupported() ? Notification.permission : 'unsupported'
  );
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Show banner if permission is default (not yet decided)
    if (permission === 'default') {
      setShowBanner(true);
    }
  }, [permission]);

  const handleRequestPermission = async () => {
    const result = await requestNotificationPermission();
    setPermission(result);
    setShowBanner(false);
  };

  const handleDismiss = () => {
    setShowBanner(false);
  };

  if (!showBanner || permission !== 'default') {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 max-w-md bg-white dark:bg-gray-800 shadow-lg rounded-lg p-4 border border-gray-200 dark:border-gray-700 z-50">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <svg
            className="h-6 w-6 text-blue-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
            />
          </svg>
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-medium text-gray-900 dark:text-white">
            Enable Notifications
          </h3>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Stay updated with leave approvals, attendance alerts, and important announcements.
          </p>
          <div className="mt-3 flex space-x-3">
            <button
              onClick={handleRequestPermission}
              className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Enable
            </button>
            <button
              onClick={handleDismiss}
              className="inline-flex items-center px-3 py-1.5 border border-gray-300 dark:border-gray-600 text-xs font-medium rounded-md text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Not Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationPermission;
